import { ChangeEvent } from 'react';
import { Box } from '@nimbus-ds/components';
import { CreateMetaplanRequestDto } from '@tiendanube/common';
import {
  NameCard,
  FrequencyCard,
  PromotionCard,
  ApplyToCard,
} from './components';

export type MetaplanFormValues = CreateMetaplanRequestDto;

export interface MetaplanFormProps {
  mode: 'edit' | 'add';
  values: MetaplanFormValues;
  errors: Partial<Record<string, string>>;
  metaplanId?: string;
  setFieldValue: (name: string, value: any) => void;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onChangeSelect: (e: ChangeEvent<HTMLSelectElement>) => void;
  cleanErrors?: () => void;
  onChangeProducts: (productIds: number[]) => void;
  excludedProductIds?: string[];
}

export function MetaplanForm({
  mode,
  values,
  errors,
  metaplanId,
  onChange,
  setFieldValue,
  cleanErrors,
  onChangeProducts,
  excludedProductIds = [],
}: Readonly<MetaplanFormProps>) {
  const disabled = mode === 'edit';

  return (
    <Box display="flex" flexDirection="column" gap="4">
      <NameCard
        values={values}
        errors={errors}
        onChange={onChange}
        disabled={disabled}
        metaplanId={metaplanId}
      />

      <FrequencyCard
        values={values}
        errors={errors}
        setFieldValue={setFieldValue}
        disabled={disabled}
        cleanErrors={cleanErrors}
      />

      <PromotionCard
        values={values}
        errors={errors}
        setFieldValue={setFieldValue}
        disabled={disabled}
      />

      <ApplyToCard
        mode={mode}
        values={values}
        errors={errors}
        onChangeProducts={onChangeProducts}
        excludedProductIds={excludedProductIds}
      />
    </Box>
  );
}
